import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

import '../css/promo_line.scss'

export default class PromoLine {

    static init() {
        const promoBlock = document.querySelector('.promo-line')

        if (promoBlock) {
            new PromoLine(promoBlock)
        }
    }

    constructor(block) {
        this.initSwiper()
        this.bindEvents(block)
    }

    initSwiper() {
        new Swiper('.promo-carousel .swiper-container', {
            slidesPerView: 1,
            allowTouchMove: false,
            navigation: {
                nextEl: '.promo-line .swiper-button-next',
                prevEl: '.promo-line .swiper-button-prev',
            },
            pagination: {
                el: '.promo-carousel .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplayDisableOnInteraction: false,
            on: {
                slideChange: (swiper) => {
                    const prevSlide = swiper.slides[swiper.previousIndex]
                    const iframe = prevSlide.querySelector('iframe')
                    const video = prevSlide.querySelector('video')

                    if (iframe) {
                        const src = iframe.src
                        iframe.src = src
                    }
                    if (video) {
                        video.pause()
                    }
                }
            }
        })
    }

    bindEvents(block) {
        this.onWindowResize(block)
    }

    onWindowResize(block) {
        window.addEventListener('resize', () => {
            const mobile = document.documentElement.clientWidth < 762
            if (mobile) {
                this.setContentMinHeight(block)
            } else {
                this.removeContentMinHeight(block)
            }
        })
    }

    removeContentMinHeight(block) {
        const sliderItemContents = block.querySelectorAll('.item-content')

        sliderItemContents.forEach(element => {
            element.style.removeProperty('min-height')
        })

    }

    setContentMinHeight(block) {
        const sliderItemContents = block.querySelectorAll('.item-content')

        let maxHeight = 0.0
        sliderItemContents.forEach(element => {
            if (maxHeight < element.offsetHeight) {
                maxHeight = element.offsetHeight
            }
        })

        sliderItemContents.forEach(element => {
            element.style.minHeight = `${maxHeight}px`
        })
    }
}
